import React, { useEffect, useState } from 'react';
import { Badge, Button, Card, Form, Modal, Table } from 'react-bootstrap';
import { IoAddOutline, IoArrowBackOutline, IoCreateOutline, IoSyncOutline } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router';
import axios from 'axios';
import { useAuth } from '../../../../context/AuthContext';
import { BarLoader, ClipLoader } from 'react-spinners';
import UserForm from '../../../../components/forms/customers/create-user';
import { toast } from 'react-toastify';
import ToggleSwitch from '../../../../components/custom-utils/toggleSwitch';

function Details() {

  const { user } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const masterData = location.state;

  const [isSwitching, setIsSwitching] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showUser, setShowUser] = useState(false);
  const [usersData, setUsersData] = useState([]);

  const handleClose = () => setShowUser(false);
  const handleShow = () => setShowUser(true);

  function listAllUsers(accessToken, uid, bid) {
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_FIREBASE_PROVIDER_URL}/users`,
      headers: {
        "idToken": accessToken,
        "uid": uid,
        "bid": bid
      }
    };
    axios.request(config)
      .then((response) => {
        if (response.status === 200) {
          setUsersData(response.data);
          setIsLoading(false);
        }
      }).catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (usersData && usersData.length === 0) {
      listAllUsers(user.accessToken, user.uid, masterData.id);
    }
  }, []);

  function handleUserData(userData) {
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_FIREBASE_PROVIDER_URL}/create-user`,
      data: userData,
      headers: {
        "idToken": user.accessToken,
        "uid": user.uid
      }
    };

    axios.request(config)
      .then((response) => {
        if (response.status === 201) {
          setShowUser(false);
        }
      }).catch((error) => {
        toast.error(error && error.message);
      });
  }

  function updateUserStatus(uid, value) {
    setIsSwitching(true);
    let config = {
      method: 'post',
      url: `${process.env.REACT_APP_FIREBASE_PROVIDER_URL}/update-user-status`,
      data: {
        uid: uid,
        disabled: value
      },
      headers: {
        "idToken": user.accessToken,
        "uid": user.uid
      }
    };
    axios.request(config)
      .then((response) => {
        if (response.status === 200) {
          listAllUsers();
          if (response.data.userData.disabled) {
            toast.error('User Disabled');
          } else {
            toast.success('User Enabled');
          }
          setIsSwitching(false);
        }
      }).catch((error) => {
        toast.error(error.response.data.message);
      });
  }

  return (
    <section className='p-3'>
      <div className='bg-white rounded p-3 mb-3'>
        <div className='row align-items-center justify-content-center'>
          <div className='col-md-8'>
            <div className='d-flex align-items-center'>
              <Button
                variant='none'
                className='shadow-none border rounded-circle p-0 p-2'
                onClick={() => navigate(-1)}
              >
                <IoArrowBackOutline size={20} />
              </Button>
              <h4 className='mb-0 ms-3'>{masterData && masterData.businessName}</h4>
              <div className='d-flex justify-content-end ms-3'>
                {
                  masterData && masterData.status === 'active' ?
                    <Badge bg="success" className='fw-normal'>
                      Active
                    </Badge>
                    : masterData && masterData.status === 'suspended' ?
                      <Badge bg="danger" className='fw-normal'>
                        Suspended
                      </Badge>
                      : masterData && masterData.status === 'cancelled' ?
                        <Badge bg="danger" className='fw-normal'>
                          Not Subscribe Yet!
                        </Badge>
                        :
                        <Badge bg="dark" className='fw-normal'>
                          No Subscription
                        </Badge>
                }
              </div>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='d-flex justify-content-end'>
              <Button
                variant='outline-primary'
                className='px-5 py-2'
              >
                <IoCreateOutline size={20} />
                <span className='ms-2'>Edit</span>
              </Button>
              <Button
                variant='primary'
                className='py-2 ms-3'
              >
                <IoSyncOutline size={20} />
                <span className='ms-2'>Renew</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Card className='p-3 border-0 shadow-sm'>
        <div className='row border-bottom mb-3'>
          <div className='col-md-6'>
            <Form.Group>
              <Form.Label className='mb-0'>Created On</Form.Label>
              <p>{masterData && masterData.createdOn && new Date(masterData.createdOn._seconds * 1000).toDateString()}</p>
            </Form.Group>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <Form.Group className='text-end'>
              <Form.Label className='mb-0'>Updated On</Form.Label>
              <p>{masterData && masterData.updatedOn ? new Date(masterData.updatedOn._seconds * 1000).toDateString() : '--'}</p>
            </Form.Group>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <Form.Group>
              <Form.Label>Business Name</Form.Label>
              <p>{masterData && masterData.businessName ? masterData.businessName : '--'}</p>
            </Form.Group>
          </div>
          <div className='col-md-6'>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <p className={masterData && masterData.status === 'active' ? 'text-success' : 'text-danger'}>
                {
                  masterData && masterData.status === 'active' ? 'Active'
                    : masterData && masterData.status === 'suspended' ? 'Suspended'
                      : masterData && masterData.status === 'cancelled' ? 'Cancelled'
                        : 'No Subscription'
                }
              </p>
            </Form.Group>
          </div>
          {
            masterData && masterData.status === 'no_subscription' ?
              null
              :
              <>
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label>Activation Date</Form.Label>
                    <p>{masterData && masterData.activationDate ? masterData.activationDate.toDateString() : '--'}</p>
                  </Form.Group>
                </div>
                <div className='col-md-6'>
                  <Form.Group>
                    <Form.Label>Expiration Date</Form.Label>
                    <p>{masterData && masterData.expirationDate ? masterData.expirationDate.toDateString() : '--'}</p>
                  </Form.Group>
                </div>
              </>
          }
        </div>
        <div className='row mt-3'>
          <h5>Contact Information</h5>
          <div className='col-md-6'>
            <Form.Group>
              <Form.Label>Phone Number</Form.Label>
              <p>+91 {masterData && masterData.phoneNumber}</p>
            </Form.Group>
          </div>
        </div>
      </Card>

      <Card className='p-3 border-0 shadow-sm mt-3'>
        <div className='d-flex align-items-center justify-content-between pb-3'>
          <h5 className='mb-0'>Access Control</h5>
          <Button
            variant='dark'
            className='py-2'
            onClick={() => handleShow()}
          >
            <IoAddOutline size={20} />
            <span className='ms-1'>Create User</span>
          </Button>
        </div>
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Account Name</th>
              <th>Account</th>
              <th className='text-center'>Role</th>
              <th className='text-center'>Verification</th>
              <th className='text-center'>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              usersData && usersData.length > 0 ?
                usersData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.displayName}</td>
                      <td>{item.email}</td>
                      <td className='text-center'>{item.customClaims && item.customClaims.role}</td>
                      <td className={item.emailVerified ? 'bg-success text-white text-center' : 'bg-danger text-white text-center'}>{item.emailVerified ? 'Verified' : 'Not Verified'}</td>
                      <td className='text-center'>{item.disabled ? 'Disabled' : 'Enabled'}</td>
                      <td className='d-flex align-items-center justify-content-end'>
                        <ToggleSwitch
                          isLoading={isSwitching}
                          checked={item.disabled ? false : true}
                          onChange={() => updateUserStatus(item.uid, item.disabled ? false : true)}
                        />
                      </td>
                    </tr>
                  )
                })
                :
                <tr>
                  {
                    isLoading ?
                      <td colSpan={5}>
                        <div className='d-flex align-items-center justify-content-center'>
                          <div className='py-3'>
                            <BarLoader color="gray" />
                          </div>
                        </div>
                      </td>
                      :
                      <td colSpan={5}>
                        <h5 className='mb-0 text-muted text-center'>No User Found!</h5>
                      </td>
                  }
                </tr>
            }
          </tbody>
        </Table>
      </Card>

      <Modal
        show={showUser}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size={'lg'}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create a new user</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserForm
            bid={masterData.id}
            handleUserData={handleUserData}
            handleClose={handleClose}
          />
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default Details;
